"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CheckoutExtraHeaderImg = function CheckoutExtraHeaderImg(_ref) {
  var className = _ref.className,
    src = _ref.src,
    alt = _ref.alt,
    srcFallback = _ref.srcFallback;
  return /*#__PURE__*/_react["default"].createElement("picture", null, /*#__PURE__*/_react["default"].createElement("source", {
    srcSet: src,
    type: "image/webp"
  }), /*#__PURE__*/_react["default"].createElement(StyledCheckoutExtraHeaderImg, {
    className: className,
    alt: alt,
    src: srcFallback
  }));
};
var StyledCheckoutExtraHeaderImg = _styledComponents["default"].img.withConfig({
  displayName: "CheckoutExtraHeaderImg__StyledCheckoutExtraHeaderImg",
  componentId: "sc-c0bb3b-0"
})(["position:absolute;left:0;margin:auto;"]);
var _default = exports["default"] = CheckoutExtraHeaderImg;